import { LOAD_CART, ADD_PRODUCT, REMOVE_PRODUCT, GET_RESTURENT_AVAILABILITY, SET_TIME_SLOT_TIME, GET_TIME_SLOTS, SET_TIME_SLOT, SET_DELIVERY_DATE} from "./actionTypes";

const initialState = {
    products: [],
    selectedTimeSlotId: 0,
    selectedTimeSlot: 'No-Slot Selected',
    deliveryDate: new Date(),
    isResturentAvailable: true,
    RestuarentIsAvailableMessage: ''
};

export default function(state = initialState, action) {
    switch (action.type) {
        case LOAD_CART:
            return {
                ...state,
                products: action.payload
            };
        case ADD_PRODUCT:
            return {
                ...state,
                productToAdd: Object.assign({}, action.payload)
            };
        case REMOVE_PRODUCT:
            return {
                ...state,
                productToRemove: Object.assign({}, action.payload)
            };
            case GET_TIME_SLOTS:
                return {
                    ...state,
                    timeSlots: action.payload
                };
            case SET_TIME_SLOT:
                return {
                    ...state,
                    selectedTimeSlotId: action.payload
                };
            case SET_DELIVERY_DATE:
                return {
                    ...state,
                    deliveryDate: action.payload
                };
            case SET_TIME_SLOT_TIME:
                return {
                    ...state,
                    selectedTimeSlot: action.payload
                };
            case GET_RESTURENT_AVAILABILITY:
                return {
                    ...state,
                    isResturentAvailable: action.payload.success,
                    RestuarentIsAvailableMessage: action.payload.message
                };
        default:
            return state;
    }
}
